<template>
  <ValidationObserver slim v-slot="state" tag="div" class="lib__field">
    <ValidationProvider slim rules="required" tag="div" class="lib__tiles">
      <TileRadio inlineContent :label="$t('new-connection-cmh.address-step.singleFamilyHome')" :description="$t('new-connection-cmh.address-step.singleFamilyHomeDescription')" :group="'house'" item="house" v-model="selection">
        <template v-slot:picture>
          <img :src="require('@/assets/house.svg')" alt="">
        </template>
      </TileRadio>

      <TileRadio inlineContent :label="$t('new-connection-cmh.address-step.building')" :description="$t('new-connection-cmh.address-step.buildingDescription')" :group="'building'" item="building" v-model="selection">
        <template v-slot:picture>
          <img :src="require('@/assets/building.svg')" alt="">
        </template>
      </TileRadio>
    </ValidationProvider>
    <error-message :error="firstError(state.errors)"></error-message>
  </ValidationObserver>
</template>

<script lang="ts">
import Vue from 'vue'
import { Watch, Emit, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { helper } from '@/services'
import { BuildingType } from '@/models/building-type'

@Component({
  name: 'building-type-selector'
})
export default class BuildingTypeSelector extends Vue {
  @Prop({ type: String, required: false, default: '' }) public stateSelection!: BuildingType

  public selection: BuildingType = BuildingType.unknown

  public firstError(errors: { [key: string]: string[] }): string | null {
    for (const source of Object.values(errors)) {
      if (source.length > 0) {
        return source[0]
      }
    }

    return null
  }

  @Watch('selection', { deep: true })
  public onSelectionChanged(): void {
    this.onSelectionChangeHandler()
  }

  public onSelectionChangeHandler(): void {
    this.emitSelectionChanged()
  }

  @Emit('selectionChanged')
  public emitSelectionChanged(): BuildingType {
    return this.selection
  }

  public mounted() {
    this.selection = helper.clone(this.stateSelection)
  }
}
</script>
